(() => {
  if (window.__campoNobleCartInitialized) return;
  window.__campoNobleCartInitialized = true;

  const REGION_KEY = 'region';
  const TOWN_KEY = 'comuna';
  const REGION_PLACEHOLDER = 'Selecciona tu región';
  const TOWN_PLACEHOLDER = 'Selecciona tu comuna';
  const cartClearRoute = window.theme?.routes?.cartClear || '/cart/clear';
  const CART_CLEAR_URL = cartClearRoute.endsWith('.js') ? cartClearRoute : `${cartClearRoute}.js`;

  const getConfig = () => window.CampoNobleRegionConfig || { regions: [] };

  const parseTowns = (value) => Array.from(new Set((value || '')
    .split(/\r?\n/)
    .map((town) => town.trim())
    .filter(Boolean)));

  const getRegions = () => {
    const regions = {};
    const configured = Array.isArray(getConfig().regions) ? getConfig().regions : [];
    configured.forEach((region) => {
      const code = (region.code || '').trim().toUpperCase();
      const towns = parseTowns(region.towns);
      if (region.enabled && code && towns.length) regions[code] = { ...region, code, towns };
    });
    return regions;
  };

  const getCookie = (key) => {
    const name = `${encodeURIComponent(key)}=`;
    const cookie = document.cookie.split('; ').find((item) => item.startsWith(name));
    return cookie ? decodeURIComponent(cookie.slice(name.length)) : '';
  };

  const getStored = (key) => {
    try {
      return localStorage.getItem(key) || getCookie(key);
    } catch (error) {
      return getCookie(key);
    }
  };

  const getRegionTags = () => {
    const tags = {};
    Object.values(getRegions()).forEach((region) => {
      const productTag = (region.productTag || '').trim().toLowerCase();
      if (productTag) tags[region.code] = productTag;
    });
    return tags;
  };

  const parseTags = (value) => (value || '')
    .split(',')
    .map((tag) => tag.trim().toLowerCase())
    .filter(Boolean);

  const isAvailable = (tagValue, region) => {
    const tags = parseTags(tagValue);
    const regionTags = getRegionTags();
    const allRegionalTags = Object.values(regionTags);
    if (!region || !regionTags[region]) return false;
    if (!tags.some((tag) => allRegionalTags.includes(tag))) return false;
    return tags.includes(regionTags[region]);
  };

  const fillRegions = (select, selected = '') => {
    select.innerHTML = `<option value="">${REGION_PLACEHOLDER}</option>`;
    Object.values(getRegions()).forEach((region) => {
      const option = document.createElement('option');
      option.value = region.code;
      option.textContent = region.name;
      select.appendChild(option);
    });
    select.value = getRegions()[selected] ? selected : '';
  };

  const fillTowns = (select, region, selected = '') => {
    select.innerHTML = `<option value="">${TOWN_PLACEHOLDER}</option>`;
    const towns = getRegions()[region]?.towns || [];
    towns.forEach((town) => {
      const option = document.createElement('option');
      option.value = town;
      option.textContent = town;
      select.appendChild(option);
    });
    select.value = towns.includes(selected) ? selected : '';
  };

  const commitSelection = (region, town) => {
    window.dispatchEvent(new CustomEvent('campo-noble:set-region', {
      detail: { region, comuna: town, source: 'cart' }
    }));
  };

  const setModalVisible = (root, visible) => {
    const modal = root.querySelector('.js-cart-region-confirmation');
    if (!modal) return;
    if (visible && !modal.open) modal.showModal();
    if (!visible && modal.open) modal.close();
    document.body.classList.toggle('cart-region-confirmation-open', visible);
    if (visible) root.querySelector('.js-cart-region-cancel')?.focus();
  };

  const syncSelector = (root, region = getStored(REGION_KEY), town = getStored(TOWN_KEY)) => {
    const regionSelect = root.querySelector('.js-cart-region-select');
    const townSelect = root.querySelector('.js-cart-town-select');
    if (!regionSelect || !townSelect) return;
    fillRegions(regionSelect, region);
    fillTowns(townSelect, regionSelect.value, town);
    regionSelect.classList.remove('is-invalid');
    townSelect.classList.remove('is-invalid');
    const alert = root.querySelector('.js-cart-region-alert');
    if (alert) alert.hidden = true;
  };

  const refreshCart = () => {
    if (document.getElementById('cart-drawer')) {
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
      return;
    }
    document.querySelectorAll('cart-items').forEach((cartItems) => {
      if (typeof cartItems.refreshCartItems === 'function') cartItems.refreshCartItems();
    });
  };

  const initSelector = (root) => {
    if (root.dataset.cartRegionInitialized === 'true') return;
    const regionSelect = root.querySelector('.js-cart-region-select');
    const townSelect = root.querySelector('.js-cart-town-select');
    const accept = root.querySelector('.js-cart-region-accept');
    const cancel = root.querySelector('.js-cart-region-cancel');
    if (!regionSelect || !townSelect || !accept || !cancel) return;

    let pendingRegion = '';
    let pendingTown = '';
    syncSelector(root);

    const restore = () => {
      pendingRegion = '';
      pendingTown = '';
      syncSelector(root);
      setModalVisible(root, false);
      window.dispatchEvent(new CustomEvent('campo-noble:reset-region-draft'));
    };

    const requestChange = (region, town) => {
      pendingRegion = region;
      pendingTown = town;
      fillRegions(regionSelect, pendingRegion);
      fillTowns(townSelect, pendingRegion, pendingTown);
      setModalVisible(root, true);
    };

    regionSelect.addEventListener('change', () => {
      pendingRegion = regionSelect.value;
      pendingTown = '';
      fillTowns(townSelect, pendingRegion);
      regionSelect.classList.remove('is-invalid');
      townSelect.classList.remove('is-invalid');
    });

    townSelect.addEventListener('change', () => {
      pendingRegion = regionSelect.value;
      pendingTown = townSelect.value;
      townSelect.classList.remove('is-invalid');
      if (!pendingRegion || !pendingTown) return;

      const regionChanged = pendingRegion !== getStored(REGION_KEY);
      const hasCartItems = Number(root.dataset.cartCount || 0) > 0;
      if (regionChanged && hasCartItems) {
        setModalVisible(root, true);
      } else {
        commitSelection(pendingRegion, pendingTown);
      }
    });

    cancel.addEventListener('click', restore);
    root.querySelector('.js-cart-region-confirmation')?.addEventListener('cancel', (event) => {
      event.preventDefault();
      restore();
    });
    accept.addEventListener('click', async () => {
      if (!pendingRegion || !pendingTown) return;
      accept.disabled = true;
      cancel.disabled = true;
      try {
        const response = await fetch(CART_CLEAR_URL, {
          method: 'POST',
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error(response.status);
        commitSelection(pendingRegion, pendingTown);
        setModalVisible(root, false);
        refreshCart();
      } catch (error) {
        accept.disabled = false;
        cancel.disabled = false;
      }
    });

    root._campoNobleCartRegionController = { requestChange };
    root.dataset.cartRegionInitialized = 'true';
  };

  const markSelectionInvalid = (root) => {
    if (!root) return false;
    const regionSelect = root.querySelector('.js-cart-region-select');
    const townSelect = root.querySelector('.js-cart-town-select');
    const alert = root.querySelector('.js-cart-region-alert');
    const valid = Boolean(regionSelect?.value && townSelect?.value);
    regionSelect?.classList.toggle('is-invalid', !regionSelect.value);
    townSelect?.classList.toggle('is-invalid', !townSelect.value);
    if (alert) alert.hidden = valid;
    return valid;
  };

  const applyCartAvailability = (region = getStored(REGION_KEY), showMessages = true) => {
    let hasUnavailable = false;
    document.querySelectorAll('.cart-item[data-product-tags]').forEach((item) => {
      const unavailable = !isAvailable(item.dataset.productTags, region);
      item.classList.toggle('cart-item--region-unavailable', unavailable && showMessages);
      const message = item.querySelector('[data-cart-region-unavailable]');
      if (message) message.hidden = !(unavailable && showMessages);
      if (unavailable) hasUnavailable = true;
    });
    const hasCompleteSelection = Boolean(region && getStored(TOWN_KEY));
    document.querySelectorAll('.dynamic-cart-btns').forEach((buttons) => {
      buttons.hidden = !hasCompleteSelection || hasUnavailable;
    });
    return !hasUnavailable;
  };

  const buildCheckoutAction = (form, region, town) => {
    const action = (form.getAttribute('action') || '/cart').split('?')[0];
    const params = new URLSearchParams();
    params.set('step', 'contact_information');
    params.set('checkout[shipping_address][country]', 'CL');
    params.set('checkout[shipping_address][province]', region);
    params.set('checkout[shipping_address][city]', town);
    form.setAttribute('action', `${action}?${params.toString()}`);
  };

  const validateCheckout = (form) => {
    const root = form.querySelector('.js-cart-region-selector') || document.querySelector('.js-cart-region-selector');
    const selectionValid = markSelectionInvalid(root);
    const region = root?.querySelector('.js-cart-region-select')?.value || getStored(REGION_KEY);
    const town = root?.querySelector('.js-cart-town-select')?.value || getStored(TOWN_KEY);
    const productsValid = applyCartAvailability(region, true);
    if (selectionValid && productsValid) buildCheckoutAction(form, region, town);
    if (!selectionValid) root?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    else if (!productsValid) document.querySelector('.cart-item--region-unavailable')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return selectionValid && productsValid;
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll('.js-cart-region-selector').forEach(initSelector);
    applyCartAvailability();
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('#cart, #cart-drawer-form');
    if (!form) return;
    const submitter = event.submitter || document.activeElement;
    if (submitter?.name && submitter.name !== 'checkout') return;
    if (!validateCheckout(form)) event.preventDefault();
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();

  window.addEventListener('campo-noble:region-change', (event) => {
    document.querySelectorAll('.js-cart-region-selector').forEach((root) => syncSelector(root, event.detail?.region, event.detail?.comuna));
    applyCartAvailability(event.detail?.region);
  });
  window.addEventListener('campo-noble:before-region-change', (event) => {
    const nextRegion = (event.detail?.region || '').trim().toUpperCase();
    const nextTown = event.detail?.comuna || '';
    const currentRegion = getStored(REGION_KEY);
    if (!currentRegion || !nextRegion || nextRegion === currentRegion) return;

    const root = Array.from(document.querySelectorAll('.js-cart-region-selector')).find((selector) => {
      const drawer = selector.closest('#cart-drawer');
      const cartIsVisible = !drawer || drawer.getAttribute('aria-hidden') === 'false';
      return cartIsVisible && Number(selector.dataset.cartCount || 0) > 0 && selector._campoNobleCartRegionController;
    });
    if (!root) return;

    event.preventDefault();
    root._campoNobleCartRegionController.requestChange(nextRegion, nextTown);
  });
  document.addEventListener('on:line-item:change', () => requestAnimationFrame(() => initialize()));
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));

  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      initialize();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
